import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@common/hooks';
import FormCertificationTemplate from './form-certification-template';
import { createMessage } from 'works/legacy/lib/message-helper';
import { UpdateCertificationItemTemplate } from 'works/legacy/graphql/works-list-item-template';
import { addErrorsToForm } from 'works/legacy/lib/form-helpers';

export default function EditCertificationTemplate({ dismiss, item, form }) {
  const handleMutationCompletion = (response) => {
    if (response.updateCertificationItemTemplate.errors) {
      addErrorsToForm(form, response.updateCertificationItemTemplate.errors);

      createMessage(
        'error',
        'Failed to update Compliance Item. Please try again.'
      );
    } else {
      createMessage('success', 'Compliance Item updated!');
      dismiss();
    }
  };

  const [updateCertification] = useMutation(UpdateCertificationItemTemplate, {
    onCompleted: handleMutationCompletion,
    onError: () =>
      createMessage(
        'error',
        'Failed to update Compliance Item. Please try again.'
      ),
  });

  const handleSubmit = (values) => {
    updateCertification({
      variables: {
        itemId: item.id,
        input: values,
      },
    });
  };

  const initialValues = {
    certificationId: item.certification.id,
    active: item.active,
    name: item.name,
    description: item.description,
    expirationType: item.expirationType,
    daysToExpiry: item.daysToExpiry,
  };

  return (
    <FormCertificationTemplate
      initialValues={initialValues}
      dismiss={dismiss}
      handleSubmit={handleSubmit}
      showExpiration
      form={form}
    />
  );
}

EditCertificationTemplate.propTypes = {
  dismiss: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};
